import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import Img from "../../assets/images/aboutImg.jpg";
import {
  dataabout,
  meta,
  // worktimeline,
  // skills,
  services,
} from "../../content_option";
import Footer from "../../components/footer";
import TestimonalComponent from "../../components/testimonal";
import Process from "../../components/process";
import StaticAbout from "../../components/aboutSection/staticAbout";
import bgGiff from "../../assets/videos/aboutBg.mp4";
import { VscCalendar, VscBookmark } from "react-icons/vsc";
import { SlCallIn } from "react-icons/sl";
export const About = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title> About | {meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>
      <div style={{ position: "relative" }}>
        <video
          src={bgGiff}
          autoPlay
          loop
          muted
          style={{
            height: "38vh",
            width: "100%",
            position: "absolute",
            objectFit: "cover",
            zIndex: "-1",
            top: 0,
          }}
        ></video>
 
      </div>
      <div>
        <Container className="About-header">
          <Row className="mb-4 mt-5 pt-5">
            <Col lg="8">
              <h1 className="display-4 mb-4">About Us</h1>
              <hr className="t_border my-4 ml-0 text-left" />
            </Col>
          </Row>
          <Row className="sec_sp text">
            <img src={Img} alt="" />

            <Col lg="7" className="d-flex align-items-center">
              <div>
                <p>{dataabout.aboutme}</p>
              </div>
            </Col>
          </Row>
          <Row className="mb-4 mt-5 pt-5">
            <Col lg="8">
              <h1 className="display-4 mb-4">The Process</h1>
              <hr className="t_border my-4 ml-0 text-left" />
            </Col>
          </Row>
          <Row className="sec_sp text">
          <div className="inner sec_sp">
        <div className="availability card1" data-aos="fade-right">
          <SlCallIn />
          <h4>Drop your query</h4>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Esse
            praesentium corporis maxime,
          </p>
        </div>
        <div className="consult card1" data-aos="fade-up">
          <VscCalendar />
          <h4>Schedule a Meeting</h4>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Esse
            praesentium corporis maxime,
          </p>
        </div>
        <div className="dates card1" data-aos="fade-left">
          <VscBookmark />
          <h4>Book the Date</h4>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Esse
            praesentium corporis maxime,
          </p>
        </div>
      </div>
          </Row>
          <Row className="sec_sp services">
            <Col lang="5  " className="ser_head" data-aos="fade-left">
              <h3 className="color_sec  py-4">Our services</h3>
            </Col>
            <Col lg="7">
              {services.map((data, i) => {
                return (
                  <div className="service_ py-4" key={i}>
                    <h5 className="service__title">{data.title}</h5>
                    <p className="service_desc">{data.description}</p>
                  </div>
                );
              })}
            </Col>
          </Row>
          <StaticAbout />
          <TestimonalComponent />
        </Container>
      </div>
      <Footer />
    </HelmetProvider>
  );
};
